// export const baseUrl = "https://savani.areumjewels.com";
export const baseUrl = "https://apisavani.sparkflows.in";
// export const baseUrl = "https://h5gtm208-3002.inc1.devtunnels.ms";
// export const baseUrl = "https://ngcz8dv0-3002.inc1.devtunnels.ms/";
